/**
 * Created by mzietek on 2016-11-23.
 */

(function (angular) {
    'use strict';

    angular
        .module("repairforms.constant.module")
        .constant("NoWarrantyOptions", NoWarrantyOptions());

    function NoWarrantyOptions() {

        return {
            getOptions : getOptions
        };

        function getOptions() {
            return {
                NONE: 'NONE',
                FIXED_PRICE: 'FIXED_PRICE',
                VOUCHER: 'VOUCHER',
                CASHBACK: 'CASHBACK'
            };
        }
    }

})(angular);